const maps = {};
window.addEventListener('DOMContentLoaded', renderAllMaps);

function createMap(element) {
  import(/* webpackChunkName: "dmnp-mapbox" */ './dmnp-mapbox').then(
    ({ mapboxgl }) => {
      const { lon, lat, zoom, marker } = element.dataset;

      const map = new mapboxgl.Map({
        accessToken:
          'pk.eyJ1IjoiYXZlcnllbGxlciIsImEiOiJjamx3bGtwcHUwMHdnM3dtY2h6bTNuZmd2In0.xdACIps6VbrcL6f4VGNrhA',
        container: element,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [lon, lat],
        zoom,
      });

      maps[element.id] = map;

      if (marker) {
        new mapboxgl.Marker(createMarker(marker))
          .setLngLat([lon, lat])
          .addTo(map);
      }
    }
  );
}

function refreshMap({ id, lon, lat, zoom }) {
  if (maps[id]) {
    maps[id].resize();
    maps[id].flyTo({
      center: [lon, lat],
      zoom,
    });
  }
}

function renderAllMaps() {
  const mapElements = document.querySelectorAll('.map');
  mapElements.forEach(createMap);
}

function createMarker(marker, width = 36, height = 36) {
  const imgElement = document.createElement('img');
  imgElement.className = 'cobp-marker-image';
  imgElement.style.width = `${width}px`;
  imgElement.style.height = `${height}px`;
  imgElement.setAttribute('src', marker);
  imgElement.setAttribute('width', width);
  imgElement.setAttribute('height', height);
  imgElement.setAttribute('alt', 'Map marker pin for our location.');

  const mkrElement = document.createElement('div');
  mkrElement.className = 'cobp-marker';
  mkrElement.style.width = `${width}px`;
  mkrElement.style.height = `${height}px`;
  mkrElement.setAttribute('aria-label', 'Map marker.');

  mkrElement.appendChild(imgElement);

  return mkrElement;
}

export { renderAllMaps, refreshMap };
